import { FloatingButtons } from "./Component/FloatingButtons";
import { Footer } from "./Component/Footer";
import { LanguageProvider } from "./Component/LanguageProvider";
import { Navbarr } from "./Component/Navbarr";
import AboutUsPage from "./Pages/AboutUsPage";
import { HomePage } from "./Pages/HomePage";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import OurservicePage from "./Pages/OurservicePage";
import BlogsPage from "./Pages/BlogsPage";
import ContactPage from "./Component/ContactPage";
import DashboardLayout from "./Component/Auth/DashboardLayout";
import Login from "./Component/Auth/Login";
import { ManageExpensesAndDeposites } from "./Component/Accounting/ManageExpensesAndDeposites";


// عملنا كومبوننت منفصل جواه الـ Router عشان نقدر نستخدم useLocation
function MainLayout() {
  const location = useLocation();
  
  // المسارات اللي مش عايز الـ navbar يظهر فيها
  const hideNavbarPaths = ['/Login', '/admin/dashboard', '/admin/dashboard/clients','/expenses'];
  
  // التحقق إذا كان المسار الحالي من المسارات المخفية
  const shouldHideNavbar = hideNavbarPaths.includes(location.pathname);
  
  return (
    <>
      {!shouldHideNavbar && <Navbarr />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutUsPage />} />
        <Route path="/services" element={<OurservicePage />} />
        <Route path="/blogs" element={<BlogsPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/admin/dashboard" element={<DashboardLayout />} />
        <Route path="/Login" element={<Login />} />
                <Route path="/expenses" element={<ManageExpensesAndDeposites />} />

        <Route path="*" element={<HomePage />} />
      </Routes>
            {!shouldHideNavbar &&<Footer />}

                  {!shouldHideNavbar &&<FloatingButtons />}

      
    </>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <MainLayout />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;